function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionalArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5026 11.6666L3.33594 7.49992L7.5026 3.33325",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6693 16.6667V10.8333C16.6693 9.94928 16.3181 9.10143 15.693 8.47631C15.0678 7.85119 14.22 7.5 13.3359 7.5H3.33594",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionalArrows);
export default __webpack_public_path__ + "static/media/DirectionalArrows.a01ad6e820f4fa1d07a00450c599e5ce.svg";
export { ForwardRef as ReactComponent };